import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { MessagesStore } from '../stores';
import { IAEventList } from './eventList/EventList';
import { IACardViewService } from '../../messagesCardView/CardView.service';
import { IMessage } from '../../../interfaces/IMessage';

export interface IEventListViewProps {
  messagesStore?: MessagesStore;
}

@inject('messagesStore')
@observer
export default class EventListView extends React.Component<IEventListViewProps> {

  private LIST_ELEMENT_PADDING = 20;
  private LIST_ELEMENT_MIN_WIDTH = 237;
  private LIST_ELEMENT_MAX_WIDTH = 364;
  private cardViewService: IACardViewService = new IACardViewService();

  constructor(props) {
    super(props);
  }

  private skeletonListElements(): JSX.Element[] {
    const [numberOfCardsPerRow, maxCardWidthAvailable] = this.cardViewService.getNumberOfCardsPerRowAndMaxCardWidthAvailable(this.props.messagesStore.width - 1, this.LIST_ELEMENT_PADDING, this.LIST_ELEMENT_MIN_WIDTH);
    let currentRowNumber = 1;
    let skeletonListElements = [];
    for (let i = 0; i < this.props.messagesStore.numMessages; i++) {
      skeletonListElements.push(
        <IAEventList
          key={i}
          showSkeleton={true}
          backgroundColor="transparent"
          borderRadius={this.props.messagesStore.borderRadius}
          marginRight={currentRowNumber == numberOfCardsPerRow ? 0 : this.LIST_ELEMENT_PADDING}
          width={window.innerWidth < 667 ? window.innerWidth - 56 : maxCardWidthAvailable}
          maxWidth={window.innerWidth < 667 ? window.innerWidth - 56 : this.LIST_ELEMENT_MAX_WIDTH}
        />
      );
      if (currentRowNumber == numberOfCardsPerRow) {
        currentRowNumber = 1;
      } else {
        currentRowNumber++;
      }
    }
    return skeletonListElements;
  }

  private showListElements(): JSX.Element[] {
    let listElements: JSX.Element[] = [];
    // Resizing ListElements
    const [numberOfCardsPerRow, maxCardWidthAvailable] = this.cardViewService.getNumberOfCardsPerRowAndMaxCardWidthAvailable(this.props.messagesStore.width - 1, this.LIST_ELEMENT_PADDING, this.LIST_ELEMENT_MIN_WIDTH);
    let currentRowNumber = 1;

    let itemsToShow: IMessage[] = [];
    if (this.props.messagesStore.isMobile) {
      itemsToShow = this.props.messagesStore.messages;
    } else {
      const startIndex = (this.props.messagesStore.pageNumber - 1) * this.props.messagesStore.numMessages;
      const endIndex = this.props.messagesStore.pageNumber * this.props.messagesStore.numMessages;
      itemsToShow = this.props.messagesStore.messages.slice(startIndex, endIndex)
    }
    for (let i = 0; i < itemsToShow.length; i++) {
      if (itemsToShow[i] != undefined) {
        listElements.push(
          <IAEventList
            key={`${itemsToShow[i].id}_${itemsToShow[i].startDate}`}
            id={itemsToShow[i].id.toString()}
            image={itemsToShow[i].image}
            title={itemsToShow[i].title}
            content={itemsToShow[i].content}
            startDate={itemsToShow[i].startDate}
            allDayEvent={itemsToShow[i].allDayEvent}
            endDate={itemsToShow[i].endDate}
            categories={itemsToShow[i].categories}
            location={itemsToShow[i].location}
            highlightColor={this.props.messagesStore.rollupHighlightColor}
            backgroundColor={this.props.messagesStore.backgroundColor}
            textColor={this.props.messagesStore.textColor}
            dateBadgeBackgroundColor={this.props.messagesStore.dateBadgeBackgroundColor}
            dateBadgeTextColor={this.props.messagesStore.dateBadgeTextColor}
            dateBorderColor={this.props.messagesStore.dateBorderColor}
            borderColor={this.props.messagesStore.borderColor}
            borderRadius={this.props.messagesStore.borderRadius}
            showDropShadow={this.props.messagesStore.showDropShadow}
            marginRight={currentRowNumber == numberOfCardsPerRow ? 0 : this.LIST_ELEMENT_PADDING}
            width={window.innerWidth < 667 ? window.innerWidth - 56 : maxCardWidthAvailable}
            maxWidth={window.innerWidth < 667 ? window.innerWidth - 56 : this.LIST_ELEMENT_MAX_WIDTH}
            showCategories={this.props.messagesStore.showCategories}
            showTimespand={this.props.messagesStore.showTimespand}
            showLocation={this.props.messagesStore.showLocation}
            isMobile={this.props.messagesStore.isMobile}
            fontSlots={this.props.messagesStore.fontSlots}
            select={() => {
              this.props.messagesStore.openMessage(itemsToShow[i]);
            }}
          />
        );
      }
      if (currentRowNumber == numberOfCardsPerRow) {
        currentRowNumber = 1;
      } else {
        currentRowNumber++;
      }
    }
    return listElements;
  }

  public render(): JSX.Element {
    let showSkeleton = !(!this.props.messagesStore.loading && this.props.messagesStore.messages);
    if (this.props.messagesStore.loading && this.props.messagesStore.isMobile && this.props.messagesStore.messages && this.props.messagesStore.messages.length > 0) {
      showSkeleton = false;
    }
    return (
      <div
        style={{
          width: "100%",
          overflow: "hidden",
          height: "auto",
          padding: this.props.messagesStore.isNavigator ? "0px 20px" : "0px 0px",
          boxSizing: "border-box"
        }}
        id={`cardContainer_${this.props.messagesStore.id}`}
      >
        {showSkeleton ? this.skeletonListElements() : this.showListElements()}
      </div>
    );
  }

  
}